import { styled } from '@mui/material/styles'
import { Paper } from '@mui/material'
import { Colors } from 'constants/colors'

const CardWrapper = styled(Paper)({
  padding: '20px',
  borderRadius: '10px',
  width: '100%',
  backgroundColor: Colors.backgroundDark,
  boxShadow:
    'rgba(255, 255, 255, 0.2) 0px 3px 3px -2px, rgba(255, 255, 255, 0.14) 0px 3px 4px 0px, rgba(255, 255, 255, 0.12) 0px 1px 8px 0px',
})

const CardTitle = styled('p')({
  fontSize: '22px',
  color: Colors.darkDeepGray,
  opacity: 0.7,
  fontWeight: 700,
  margin: 0,
  padding: 0,
})

const PricingContainer = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  margin: '5px 0',
})

const SymbolStyle = styled('p')({
  color: Colors.white,
  margin: 0,
  padding: 0,
  fontSize: '24px',
  fontWeight: 700,
})
const CardPricing = styled('p')({
  fontSize: '34px',
  fontWeight: 700,
  color: Colors.white,
  margin: 0,
  padding: 0,
})
const PricingText = styled('p')({
  fontSize: '26px',
  letterSpacing: '2',
  fontWeight: 400,
  color: Colors.darkCoolGray,
  opacity: 0.7,
  margin: 0,
  padding: 0,
})
const CardSubtitle = styled('p')({
  fontSize: '14px',
  fontWeight: 400,
  color: Colors.darkCoolGray,
  opacity: 0.7,
  margin: 0,
  padding: 0,
})

const CardDetailsWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: '100%',
  margin: '15px 0',
})
const CardDetails = styled('p')({
  fontSize: '12px',
  fontWeight: 400,
  color: Colors.white,
  margin: '5px 0',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
})

const SubCardStyle = {
  CardWrapper,
  CardTitle,
  CardPricing,
  CardSubtitle,
  CardDetailsWrapper,
  CardDetails,
  PricingText,
  SymbolStyle,
  PricingContainer,
}

export default SubCardStyle
